import { Component, OnInit, Input } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { recolecciondom } from '../../servicios/recoleccion-dom.service';
import jwt_decode from "jwt-decode";

interface Package {
  name: string;
  quantity: number;
  priceUnit: number;
  totalPrice: number;
  isPopular?: boolean; // Para destacar la mejor opción
  savings?: string; // Etiqueta de ahorro (marketing)
  // link: string;
  sku: string; // en vez de link
  weightDesc?: string; // Para mostrar en el modal (ej: "1 kg")
}

type TabId = '1kg' | '5kg' | 'heavy';

@Component({
  selector: 'app-guias-web-pricing',
  templateUrl: './guias-web-pricing.component.html',
  styleUrls: ['./guias-web-pricing.component.css']
})
export class GuiasWebPricingComponent implements OnInit {

  @Input() isDynamic: boolean = false;
  @Input() restrictToTop3: boolean = true;

  activeTab: TabId = '1kg';
  currentPackages: Package[] = [];

  // Modal State
  isModalOpen: boolean = false;
  selectedPkg: Package | null = null;

  heavyTabLabel = '🚛 Carga Pesada (+10kg)'; // lo que se muestra

  // Datos extraídos EXACTAMENTE de tus CSVs
  data1kg: Package[] = [
    { name: 'Emprendedor', quantity: 10, priceUnit: 229.90, totalPrice: 2299, savings: 'PARA EMPEZAR', sku: '1kg-10', weightDesc: '1 kg' },
    { name: 'Crecimiento', quantity: 25, priceUnit: 225.52, totalPrice: 5638, isPopular: true, savings: 'MÁS POPULAR', sku: '1kg-25', weightDesc: '1 kg' },
    { name: 'Alto Movimiento', quantity: 100, priceUnit: 207.90, totalPrice: 20790, savings: 'MAXIMO AHORRO', sku: '1kg-100', weightDesc: '1 kg' }
  ];

  data5kg: Package[] = [
    { name: 'Emprendedor', quantity: 10, priceUnit: 295.90, totalPrice: 2959, savings: 'PARA EMPEZAR', sku: '5kg-10', weightDesc: '5 kg' },
    { name: 'Crecimiento', quantity: 25, priceUnit: 290.52, totalPrice: 7263, isPopular: true, savings: 'MÁS POPULAR', sku: '5kg-25', weightDesc: '5 kg' },
    { name: 'Alto Movimiento', quantity: 100, priceUnit: 269.50, totalPrice: 26950, savings: 'MAXIMO AHORRO', sku: '5kg-100', weightDesc: '5 kg' }
  ];

  dataHeavy: Package[] = [
    { name: 'Emprendedor', quantity: 10, priceUnit: 317.90, totalPrice: 3179, savings: 'PARA EMPEZAR', sku: '10kg-10', weightDesc: '10 kg.' },
    { name: 'Crecimiento', quantity: 20, priceUnit: 306.90, totalPrice: 6138, isPopular: true, savings: 'MÁS POPULAR', sku: '10kg-20', weightDesc: '10 kg.' },
    { name: 'Empresarial', quantity: 30, priceUnit: 295.90, totalPrice: 8877, savings: 'RECOMENDADO', sku: '10kg-30', weightDesc: '10 kg.' }
  ];

  constructor(
    private breakpointObserver: BreakpointObserver,
    private recolecciondom: recolecciondom
  ) { }

  ngOnInit(): void {
    // Siempre cargar paquetes dinamicos como prioridad
    this.loadDynamicPackages();

    this.breakpointObserver
      .observe(['(max-width: 719px)'])
      .subscribe(r => {
        this.heavyTabLabel = r.matches ? '🚛 Carga +10kg' : '🚛 Carga Pesada (+10kg)';
      });
  }

  // Modal Handlers
  openDetails(pkg: Package) {
    this.selectedPkg = pkg;
    this.isModalOpen = true;
    document.body.style.overflow = 'hidden'; // Bloquear scroll
  }

  closeDetails() {
    this.isModalOpen = false;
    document.body.style.overflow = 'auto'; // Liberar scroll
  }

  loadDynamicPackages() {
    let idcliente = -1;
    const token = sessionStorage.getItem("token") || localStorage.getItem("token");
    if (token) {
      try {
        const decoded: any = jwt_decode(token);
        idcliente = decoded.idUser || -1;
      } catch (e) { }
    }

    this.recolecciondom.getPaquetesGuias(idcliente).then((data: any[]) => {
      if (!data) return;

      const sortPackages = (a: Package, b: Package) => {
        const wA = parseInt(String(a.weightDesc), 10) || 0;
        const wB = parseInt(String(b.weightDesc), 10) || 0;
        if (wA !== wB) return wA - wB;
        return a.quantity - b.quantity;
      };

      // Mapear y filtrar dependendiendo de si queremos sólo los 3 destacados o todos
      if (this.restrictToTop3) {
        this.data1kg = data
          .filter(p => p.descripcion1 === '1 Kg.' && [10, 25, 100].includes(Number(p.numGuias)))
          .map(p => this.mapToPackage(p, 'Pack 1KG'))
          .sort(sortPackages);

        this.data5kg = data
          .filter(p => p.descripcion1 === '5 Kg.' && [10, 25, 100].includes(Number(p.numGuias)))
          .map(p => this.mapToPackage(p, 'Pack 5KG'))
          .sort(sortPackages);

        this.dataHeavy = data
          .filter(p => {
            const n = parseInt(String(p.descripcion1), 10);
            return !isNaN(n) && n === 10 && [10, 20, 30].includes(Number(p.numGuias));
          })
          .map(p => this.mapToPackage(p, p.descripcion1.replace('.', '')))
          .sort(sortPackages);
      } else {
        this.data1kg = data
          .filter(p => p.descripcion1 === '1 Kg.')
          .map(p => this.mapToPackage(p, 'Pack 1KG'))
          .sort(sortPackages);

        this.data5kg = data
          .filter(p => p.descripcion1 === '5 Kg.')
          .map(p => this.mapToPackage(p, 'Pack 5KG'))
          .sort(sortPackages);

        this.dataHeavy = data
          .filter(p => {
            const n = parseInt(String(p.descripcion1), 10);
            return !isNaN(n) && n >= 10;
          })
          .map(p => this.mapToPackage(p, p.descripcion1.replace('.', '')))
          .sort(sortPackages);
      }

      // Destacar exclusivamente Crecimiento como popular
      [...this.data1kg, ...this.data5kg, ...this.dataHeavy].forEach(p => {
        if (p.name.includes('Crecimiento') || p.quantity === 25) {
          p.isPopular = true;
        }
      });

      this.setTab(this.activeTab);
    }).catch(err => {
      console.error("Error al cargar paquetes dinámicos", err);
      this.setTab('1kg'); // Fallback a estático si falla la API
    });
  }

  private getBadgeText(name: string): string {
    const lowerName = name.toLowerCase();
    if (lowerName.includes('emprendedor')) return 'PARA EMPEZAR';
    if (lowerName.includes('crecimiento')) return 'MÁS POPULAR';
    if (lowerName.includes('empresarial')) return 'RECOMENDADO';
    if (lowerName.includes('alto movimiento')) return 'MAXIMO AHORRO';
    if (lowerName.includes('elite')) return 'MÁXIMO VOLUMEN';
    return '';
  }

  private mapToPackage(p: any, defaultName: string): Package {
    const kg = parseInt(String(p.descripcion1), 10);
    const quantity = Number(p.numGuias);
    const totalPrice = Number(p.costo);
    const priceUnit = quantity > 0 ? totalPrice / quantity : 0;
    const name = p.nombre || defaultName;

    return {
      name: name,
      quantity: quantity,
      priceUnit: priceUnit,
      totalPrice: totalPrice,
      sku: `${kg}kg-${quantity}`,
      savings: p.promocion || this.getBadgeText(name),
      weightDesc: p.descripcion1.toLowerCase()
    };
  }

  setTab(tab: TabId) {
    this.activeTab = tab;
    if (tab === '1kg') this.currentPackages = this.data1kg;
    if (tab === '5kg') this.currentPackages = this.data5kg;
    if (tab === 'heavy') this.currentPackages = this.dataHeavy;
  }

}
